import { __rest } from "tslib";
import React from 'react';
import { usePreviewState, useResetComponent } from './hooks';
import { BlockingLayer } from './BlockingLayer';
export function withComponentPreview(WrappedComponent) {
    return React.forwardRef((_a, ref) => {
        var { previewWrapperProps = {} } = _a, viewerProps = __rest(_a, ["previewWrapperProps"]);
        const { id } = viewerProps;
        const { compPreviewState, blockingLayer: blockingLayerProps = { enabled: false }, shouldResetComponent, } = previewWrapperProps;
        usePreviewState(viewerProps.id, compPreviewState);
        const key = useResetComponent({
            id,
            shouldResetComponent,
        });
        const canDisplayTooltip = () => {
            return (
            // showTooltip is injected by a feature from thunderbolt
            // https://github.com/wix-private/thunderbolt/blob/master/packages/ds-feature-components-preview-tooltip
            viewerProps.showTooltip &&
                blockingLayerProps.tooltipText);
        };
        return (React.createElement(React.Fragment, null,
            React.createElement(WrappedComponent, Object.assign({}, viewerProps, { key: key, ref: ref })),
            blockingLayerProps.enabled && (React.createElement(BlockingLayer, Object.assign({}, (canDisplayTooltip() && {
                onClick: ev => {
                    viewerProps.showTooltip(ev.currentTarget.getBoundingClientRect(), blockingLayerProps.tooltipText);
                },
            }), { targetId: viewerProps.id })))));
    });
}
export const createPreviewFallback = (WrappedComponent) => withComponentPreview(WrappedComponent);
//# sourceMappingURL=createPreviewFallback.js.map